module.exports = __webpack_public_path__ + "img/Blue_Space_Invader.9659c77d.gif";